import { EdgeArchiveChannelRepository } from '@/modules/connect/infra'
import type { ArchiveChannel } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeArchiveChannel(): ArchiveChannel {
  return new EdgeArchiveChannelRepository(makeSupabaseEdgeHttpClient()).execute
}
